import { Logo, LogoNav, LogoNavProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'

export const LogoNavBox: FunctionComponent<LogoNavProps> = (props) => (
  <LogoNav as={Link} to='/' id='homeAction' {...props} data-testid='home-link'>
    <Logo />
  </LogoNav>
)
